/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ILP Content Delivery API
 * API for delivering educational content including course structures and glossaries
 * OpenAPI spec version: v1
 */
import useSwr from "swr";
import type { Key, SWRConfiguration } from "swr";

import type { Error, Glossary } from "../model";

import { apiFetch } from "../../apiFetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListGlossaryTermsUrl = (enrollmentId: string) => {
  return `/api/v1/enrollments/${enrollmentId}/glossaries`;
};

/**
 * Retrieves stored glossary terms for the course version pinned to the enrollment
 * @summary List glossary terms for an enrollment
 */
export const listGlossaryTerms = async (
  enrollmentId: string,
  options?: Parameters<typeof apiFetch>[1]
): Promise<Glossary> => {
  return apiFetch<Glossary>(getListGlossaryTermsUrl(enrollmentId), {
    ...options,
    method: "GET",
  });
};

export const getListGlossaryTermsKey = (enrollmentId: string) =>
  [`/api/v1/enrollments/${enrollmentId}/glossaries`] as const;

export type ListGlossaryTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGlossaryTerms>>
>;

/**
 * @summary List glossary terms for an enrollment
 */
export const useListGlossaryTerms = <TError = Error>(
  enrollmentId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listGlossaryTerms>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof apiFetch>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false &&
    enrollmentId !== null &&
    enrollmentId !== undefined;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListGlossaryTermsKey(enrollmentId) : null));
  const swrFn = () => listGlossaryTerms(enrollmentId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions
  );

  return {
    swrKey,
    ...query,
  };
};
